import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 18,
  xSmall: 15
};
const CartOneDigitBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M2.82996 5.8501H7.37603L10.6189 19.63H23.0428L26.1297 7.73636H27.1559L23.8376 20.6301H9.82388L6.58396 6.8501H2.82996V5.8501Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M11.87 23.0301C11.87 23.6431 11.373 24.1401 10.76 24.1401C10.1469 24.1401 9.64996 23.6431 9.64996 23.0301C9.64996 22.4171 10.1469 21.9201 10.76 21.9201C11.373 21.9201 11.87 22.4171 11.87 23.0301Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M23.28 24.1401C23.893 24.1401 24.39 23.6431 24.39 23.0301C24.39 22.4171 23.893 21.9201 23.28 21.9201C22.6669 21.9201 22.17 22.4171 22.17 23.0301C22.17 23.6431 22.6669 24.1401 23.28 24.1401Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M2.82996 5.8501H7.37603L10.6189 19.63H23.0428L26.1297 7.73636H27.1559L23.8376 20.6301H9.82388L6.58396 6.8501H2.82996V5.8501Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M11.87 23.0301C11.87 23.6431 11.373 24.1401 10.76 24.1401C10.1469 24.1401 9.64996 23.6431 9.64996 23.0301C9.64996 22.4171 10.1469 21.9201 10.76 21.9201C11.373 21.9201 11.87 22.4171 11.87 23.0301Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M23.28 24.1401C23.893 24.1401 24.39 23.6431 24.39 23.0301C24.39 22.4171 23.893 21.9201 23.28 21.9201C22.6669 21.9201 22.17 22.4171 22.17 23.0301C22.17 23.6431 22.6669 24.1401 23.28 24.1401Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    )
  );
};
CartOneDigitBoldIcon.iconName = "CartOneDigitBoldIcon";

export { CartOneDigitBoldIcon };
